import { RiskMapJobPositionDetailed } from '@models/riskMapJobPosition'
import { Option } from '@organisms/Select'
import { FormValues } from './index'

const getDefaultValues = (
  riskMapPosition?: Partial<RiskMapJobPositionDetailed>
): Partial<FormValues> | void => {
  const result: Partial<FormValues> = {
    titles: [null] as unknown as Option[],
    dangerDTOs: [{}],
  }

  if (!riskMapPosition) return result

  if (riskMapPosition.title) {
    result.titles = [
      { label: riskMapPosition.title, value: riskMapPosition.title },
    ]
  }

  if (riskMapPosition.riskMapJobPositionDangers) {
    result.dangerDTOs = riskMapPosition.riskMapJobPositionDangers.map(
      ({ event, kind, object, workPlace, hazard }) => {
        return {
          workPlace: workPlace
            ? {
                label: workPlace.value,
                value: workPlace['@id'],
              }
            : undefined,
          kind: kind
            ? {
                label: kind.value,
                value: kind['@id'],
              }
            : undefined,
          event: event
            ? {
                label: event.value,
                value: event['@id'],
              }
            : undefined,
          hazard: hazard
            ? {
                label: hazard.value,
                value: hazard['@id'],
              }
            : undefined,
          object: object
            ? {
                label: object.value,
                value: object['@id'],
              }
            : undefined,
        }
      }
    )
  }

  return result
}

export default getDefaultValues
